import navMenuItems from '@/navigation/vertical'

const routePaths = {
  financial: '/financeiro',
  integration: '/integracao',
  'New-Charging': '/novas-cobrancas',
  myCharging: '/cobranca/minha',
  clientes: '/clientes',
  relatorioTransacao: '/relatorio/transacao',
  relatorioRecorrencia: '/relatorio/recorrencia',
  relatorioBoleto: '/relatorio/boleto',
  relatorioGrupo: '/relatorio/grupo',
  products: '/produtos',
  'permission-management': '/permissoes',
  faleConosco: '/fale-conosco',
}

const routePermissions = {
  financial: [162],
  detailsTransaction: [162],
  detailsBankSlip: [162],
  integration: [],
  'New-Charging': [164],
  'New-Charging-ID': [164],
  myCharging: [164],
  myChargingId: [164],
  myChargingIdBankSlip: [164],
  myChargingIdRecurrence: [164],
  clientes: [165],
  novosclientes: [165],
  editarcliente: [165],
  relatorioTransacao: [166],
  relatorioRecorrencia: [166],
  relatorioBoleto: [166],
  relatorioGrupo: [166],
  products: [167],
  'permission-management': [168, 169],
}

const getStoredPermissions = () => {
  const storedPermissions = sessionStorage.getItem('menuPermissions')

  if (storedPermissions === null) return null

  try {
    return JSON.parse(storedPermissions).map(permission => Number(permission))
  } catch {
    return []
  }
}

const hasPermission = (item, permissions) => (
  !item.permissions
  || item.permissions.length === 0
  || item.permissions.some(permission => permissions.includes(Number(permission)))
)

const findFirstRoute = (items, permissions) => {
  for (const item of items) {
    if (!hasPermission(item, permissions)) continue

    if (item.children) {
      const childRoute = findFirstRoute(item.children, permissions)
      if (childRoute) return childRoute
    }

    if (item.route) return routePaths[item.route]
  }

  return null
}

export const getHomeRoute = () => {
  const permissions = getStoredPermissions()
  if (permissions === null) return '/selecionar'

  return findFirstRoute(navMenuItems, permissions) || '/selecionar'
}

export const canAccessRoute = routeName => {
  const permissions = getStoredPermissions()
  const requiredPermissions = routePermissions[routeName]

  if (permissions === null || requiredPermissions === undefined) return true

  return requiredPermissions.length === 0
    || requiredPermissions.some(permission => permissions.includes(permission))
}
